<!--用户课时-->
<template>
    <a-card style="border-left: none;">
        <div class="search">
            <a-form-model layout="inline" :model="searchForm">
                <a-form-model-item label="课时名称">
                    <a-input :maxLength="30" allowClear v-model.trim="searchForm.courseChildName"
                             placeholder="请输入课时名称"/>
                </a-form-model-item>
                <a-form-model-item label="用户名称">
                    <a-input :maxLength="30" allowClear v-model.trim="searchForm.userName" placeholder="请输入用户名称"/>
                </a-form-model-item>
                <a-form-model-item label="年级班级">
                    <a-cascader :options="gradeList" change-on-select
                                v-model="searchForm.gradeClass"
                                :fieldNames="{label: 'name', value: 'id', children: 'children'}"
                                placeholder="请选择年级班级" @change="getClassList" allowClear/>
                </a-form-model-item>
                <a-form-model-item label="课时状态">
                    <a-select class="serach-item" allowClear v-model="searchForm.status" placeholder="请选择课时状态">
                        <a-select-option value="0">未开始</a-select-option>
                        <a-select-option value="1">进行中</a-select-option>
                        <a-select-option value="2">已完成</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button @click="getPageList(1)" type="primary" html-type="button">
                        查询
                    </a-button>
                    <a-button @click="searchReset" style="margin-left: 10px;">
                        重置
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
        <div style="overflow: auto">
            <a-table
                style="min-width: 800px;"
                :columns="columns"
                :row-key="(text, index) => '' + text.classId + text.projectCourseChildUserId + index"
                :pagination="tableRelevant.tablePagination"
                :loading="tableRelevant.tableLoading"
                :locale="tableRelevant.locale"
                :dataSource="tableRelevant.tableDataSource">
                <div slot="progress" slot-scope="text, record">
                    <span v-if="text.progress === 0">
                        <a-badge status="default" text="未开始"/>
                        <a-icon type="clock-circle" theme="filled" style="margin-left: 5px;color: #c0c0c0;"/>
                    </span>
                    <span v-else-if="text.progress === 100">
                        <a-badge status="success" text="已完成"/>&nbsp;
                        <a-icon style="color: #52c41a;" type="check-circle"/>
                    </span>
                    <span v-else>
                        <a-badge status="processing" text="进行中"/>
                        {{ text.progress }}%
                    </span>
                </div>
                <div slot="action" slot-scope="text, record">
                    <a style="margin-right: 10px;"
                       @click="UserCourseChildSettlement(record)">
                        <a-icon type="tags"/>
                        结算</a>
                    <a @click="snapshotList(text, 1)">
                        <a-icon type="alert"/>
                        课时快照
                    </a>
                </div>
            </a-table>
        </div>

        <!--课时快照-->
        <a-modal title="课时快照"
                 :centered="true"
                 v-model="snapshotRelevant.visible"
                 width="85%"
                 @ok="modleOk"
                 @cancel="closeModal">
            <a-card>
                <a-spin :spinning="spinning">
                    <!-- <a-button type="primary" @click="allSnapshotReset">全部重置</a-button> -->
                    <a-button icon="plus" type="primary" @click="addContent()">添加内容</a-button>
                    <a-table style="min-width: 800px;margin-top: 15px;"
                             :scroll="{y: 350}"
                             rowKey="contentId"
                             :columns="snapshotColumns"
                             ref="mySnapshotTable"
                             :pagination="snapshotTable.tablePagination"
                             :loading="snapshotTable.tableLoading"
                             :locale="snapshotTable.locale"
                             :dataSource="snapshotTable.tableDataSource">
                        <div slot="contentType" slot-scope="text">
                            <span v-if="text === 1" style="color:#2F4056;">测评游戏</span>
                            <span v-if="text === 2" style="color:#FF5722;">训练游戏</span>
                            <span v-if="text === 3" style="color:#009688;">题目壳</span>
                            <span v-if="text === 4" style="color:#4982ff;">课程视频</span>
                            <span v-if="text === 5" style="color:#4982ff;">亲子游戏</span>
                        </div>

                        <div slot="abilityTypeName" slot-scope="text,record">
                            <div class="self_td" v-for="item in text.abilitys" :key="item.id">
                                {{ item.abilityTypeName }} -
                                {{ item.firstAbilityName }} -
                                {{ item.secondAbilityName }} -
                                {{ item.scientificName }}
                            </div>
                        </div>
                        <div slot="timeConsuming" slot-scope="text">
                            {{ text.timeConsuming > 0 ? EstimatedTime(text.timeConsuming) : '--' }}
                        </div>
                        <div slot="number" slot-scope="text">
                            {{ text.executionsNumber + " / " + text.completionTimes }}
                        </div>
                        <div slot="estimatedTime" slot-scope="text">
                            <div v-if="text.contentType == 3 || text.contentType == 5">
                                <span v-if="text.contentFinishType == 2">{{ EstimatedTime(text.estimatedTime) }}</span>
                                <spn v-else>不限时</spn>
                            </div>
                            <div v-else>{{ EstimatedTime(text.estimatedTime) }}</div>
                        </div>
                        <div slot="action" class="action" slot-scope="text">
                            <a-button type="link" @click="snapshotReset(text)">
                                替换内容
                            </a-button>
                            <a-button type="link" @click="deleteContent(text)">
                                删除
                            </a-button>
                        </div>
                    </a-table>
                </a-spin>
            </a-card>
        </a-modal>
        <!-- 执行次数 -->
        <a-modal v-model="executionsNumberVisible" title="执行次数" @ok="executionsNumberOk"
                 @cancel="executionsNumberVisible = false">
            <a-form-model layout="inline" :model="snapshotForm">
                <a-form-model-item label="执行次数" prop="executionsNumber">
                    <a-input-number style="width:150px;" :min="1" :max="9999" allowClear v-model="executionsNumber" placeholder="请输入执行次数"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <a-modal :centered="true"
                 :destroyOnClose="true"
                 @ok="replace"
                 :confirmLoading="confirmLoading"
                 @cancel="courseChildsearchReset('cancel')"
                 v-model="snapshotResetRelevant.visible"
                 title="添加内容"
                 ref="mychild"
                 width="1200px">
            <div class="search">
                <a-form-model layout="inline" :model="courseChildForm">
                  <a-form-model-item label="游戏名称">
                    <a-input allowClear placeholder="请输入游戏名称" :maxLength="20" v-model="courseChildForm.Name"/>
                  </a-form-model-item>
                  <a-form-model-item label="版本名称">
                    <a-input allowClear placeholder="请输入版本名称" :maxLength="20" v-model="courseChildForm.versionName"/>
                  </a-form-model-item>
                  <a-form-model-item label="能力维度">
                    <a-cascader v-model="selectId"
                                :options="options"
                                :load-data="loadData"
                                placeholder="请选择能力维度"
                                change-on-select
                                @change="onChange"/>
                  </a-form-model-item>
                  <a-form-model-item label="适用年龄">
                    <a-input-group compact>
                      <a-input-number style=" width: 80px; text-align: center" placeholder="最小年龄" type="number" :precision="0"
                                      :min="1" :max="150" v-model="courseChildForm.minAge"/>
                      <a-input style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~"
                               disabled/>
                      <a-input-number style="width: 80px; text-align: center;border-left:none;" placeholder="最大年龄"
                                      :precision="0" :min="courseChildForm.minAge" :max="150" type="number"
                                      v-model="courseChildForm.maxAge"/>
                    </a-input-group>
                  </a-form-model-item>
                    <a-form-model-item>
                        <a-button @click="getCourseChildTableData(1)" type="primary" html-type="button">
                            查询
                        </a-button>
                        <a-button @click="courseChildsearchReset" style="margin-left: 10px;">
                            重置
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
            <div style="overflow: auto">
                <a-table :columns="courseChildColumns"
                         :row-selection="rowSelection"
                         rowKey="id"
                         :scroll="{y: 350}"
                         :loading="courseChildTable.tableLoading"
                         :dataSource="courseChildTable.tableDataSource"
                         :pagination="courseChildTable.tablePagination">
                    <div slot="versionName" slot-scope="text">
                        {{ text.versionName ? text.versionName : '--' }}
                    </div>
                    <div slot="contentName" slot-scope="text">
                        <div class="table_div">
                            {{ text.contentName }}
                        </div>
                    </div>
                    <div slot="abilityTypeName" slot-scope="text">
                        <div class="self_td self_center" v-for="item in text.abilitys" :key="item.id">
                            {{ item.abilityTypeName }}-
                            {{ item.firstAbilityName }}-
                            {{ item.secondAbilityName }}
                        </div>
                    </div>
                    <div slot="estimatedTime" slot-scope="text,record">
                        {{ record.estimatedTime == 0 ? '--' : EstimatedTime(record.estimatedTime) }}
                    </div>
                    <div slot="device" slot-scope="text,record">
                        <span v-for="item in hardwareList" :key="item.id">
                            <img style="width: 20px;margin-left: 10px;" :src="item.icon" alt=""
                                 v-if="(item.id | text.hardwareRequirements) == text.hardwareRequirements">
                        </span>
                    </div>
                    <div slot="ages" slot-scope="text,record">
                        {{ record.minAge }} - {{ record.maxAge }}
                    </div>
                </a-table>
            </div>
        </a-modal>
    </a-card>
</template>

<script>
import {CheckPhone, tableRelevant} from "@/pages/projectImpl/js/utils";
import $Bus from "@/pages/projectImpl/js/eventBus";
import {EstimatedTime} from "@/utils/EstimatedTime";

const columns = [
    {
        title: '课时名称',
        dataIndex: 'courseName'
    },
    {
        title: '用户名称',
        dataIndex: 'realName'
    },
    {
        title: '年级',
        dataIndex: 'gradeName'
    },
    {
        title: '班级',
        dataIndex: 'className'
    },
    {
        title: '课时进度',
        scopedSlots: {customRender: 'progress'}
    },
    {
        title: '最近使用时间',
        dataIndex: 'lastUpdateProgressTime',
    },
    {
        title: '操作',
        scopedSlots: {customRender: 'action'}
    }
];
const courseChildColumns = [
    {title: '游戏名', dataIndex: 'name', width: 200},
    {title: '版本名称', scopedSlots: {customRender: 'versionName'}, width: 100},
    {
        title: '能力维度',
        class: 'testClass',
        key: 'abilityTypeName',
        align: 'center',
        width: 250,
        scopedSlots: {customRender: 'abilityTypeName'}
    },
    {title: '用时', scopedSlots: {customRender: 'estimatedTime'}, align: 'center', key: 'time'},
    {title: '设备要求', scopedSlots: {customRender: 'device'}, align: 'center', key: 'device'},
    {title: '适用年龄', scopedSlots: {customRender: 'ages'}, align: 'center', key: 'createTime'}
];
const snapshotColumns = [
    {
        title: "内容名称",
        ellipsis: true,
        dataIndex: "contentName"
    },
    {
        title: "版本名称",
        ellipsis: true,
        dataIndex: "contentVersionName"
    },
    {
        title: "内容类型",
        dataIndex: "contentType",
        scopedSlots: {customRender: 'contentType'}
    },
    {
        title: "能力类型",
        class: 'multi-column',
        width: 300,
        scopedSlots: {customRender: 'abilityTypeName'}
    },
    {
        title: "执行/完成次数",
        scopedSlots: {customRender: 'number'}
    },
    {
        title: "最高分数",
        dataIndex: "maxSocre"
    },
    {
        title: "预计用时",
        scopedSlots: {customRender: 'estimatedTime'}
    },
    {
        title: "完成用时",
        scopedSlots: {customRender: 'timeConsuming'}
    },
    {
        title: "操作",
        width: 200,
        scopedSlots: {customRender: 'action'}
    }
];
export default {
    name: "StudentsManage",
    data() {
        return {
            EstimatedTime,
            columns,
            searchForm: {
                gradeId: undefined,
                classId: undefined,
                courseChildName: undefined,
                userName: undefined,
                status: undefined,
                gradeClass: undefined
            },
            gradeList: [],
            classList: [],
            //表格相关
            tableRelevant: tableRelevant.call(this),

            spinning: false,
            snapshotColumns: snapshotColumns,
            snapshotTable: tableRelevant.call(this, this.snapshotList),
            //课时快照相关
            snapshotRelevant: {
                visible: false,
                snapshotNowId: "",
                customerCourseId: ''
            },
            //重置内容
            snapshotResetRelevant: {
                visible: false,
                //当前课时数据
                nowInfo: {},
                contentId: ""
            },
            selectedRows: [],//选中数组
            allSnapshotResetId: '',//
            //课时快照
            selectId: [],
            options: [],
            courseChildForm: {
                Enabled: true,
                Name: "",
                versionName: undefined,
                AbilityTypeId: "",
                FirstAbilityId: "",
                SecondAbilityId: "",
                minAge: undefined,
                maxAge: undefined,
            },
            //设备
            hardwareList: [
                {id: 4, name: '耳机', icon: require('@/assets/img/ej.png')},
                {id: 8, name: '麦克风', icon: require('@/assets/img/mkf.png')},
                {id: 32, name: '陀螺仪', icon: require('@/assets/img/tly.png')}
            ],
            courseChildColumns,
            courseChildTable: tableRelevant.call(this, this.getCourseChildTableData),
            selectedRowKeys: [],
            //能力类型
            ability: [],
            //一级能力
            firstAbility: [],
            //二级能力
            secondAbility: [],
            allSnapshotResetId2: '',//
            resetType: -1,//类型
            hadleTit: '',//当前操作(删除、添加、替换)
            confirmLoading: false,
            againReportLoading: false,
            isClearSnapshot: false,
            snapshotForm: {
                forceFefresh: false
            },

            // 执行次数
            executionsNumberVisible: false,
            executionsNumber: undefined,
            contentIds: []
        }
    },
    watch: {
        "lookReport.visible"() {
            if (!this.lookReport.visible) {
                this.reportTableRelevant.tableDataSource = []
            }
        }
    },
    computed: {
        rowSelection() {
            return {
                type: "radio",
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRowKeys = selectedRows;
                },
                getCheckboxProps: record => ({
                    props: {
                        name: record.name,
                        disabled: this.contentIds.includes(record.id)
                    },
                }),
            };
        },
    },
    mounted() {
        setTimeout(() => this.getPageList(), 200);
        setTimeout(() => this.getGradeList(), 200);
        const arr = ["首页", "项目实施", {
            name: "课程管理",
            path: decodeURIComponent(this.$route.query.fullPath)
        }, "用户课时"];
        $Bus.$emit("pageHeaderBreadcrumb", arr);
        this.getAbility();
        this.abilityTypeSelect(0)
    },
    methods: {
        // 能力维度
        onChange(value) {
            this.courseChildForm.AbilityTypeId = value[0];
            this.courseChildForm.FirstAbilityId = value[1];
            this.courseChildForm.SecondAbilityId = value[2];
            this.selectId = value;
        },
        loadData(selectedOptions) {
            return new Promise((resolve, reject) => {
                const targetOption = selectedOptions[selectedOptions.length - 1];
                targetOption.loading = true;
                targetOption.children = [];
                let params = {
                    pid: targetOption.id,
                    abilityType: 0
                };
                this.$http.abilitySelect(params).then(res => {
                        targetOption.loading = false;
                        targetOption.children = res.data.data.map(m => ({
                            ...m,
                            value: m.id,
                            label: m.name,
                            isLeaf: m.levelNumber > 1
                        }))
                        this.options = [...this.options];
                        resolve(targetOption.children)
                });
            })
        },
        abilityTypeSelect(level) {
            let params = {
                level: level,
                abilityType: 0
            };
            this.$http.abilitySelect(params).then(res => {
                    this.options = res.data.data;
                    this.options.forEach(item => {
                        item.value = item.id;
                        item.label = item.name;
                        item.isLeaf = false;
                    });
                    if (this.courseChildForm.AbilityTypeId) {
                        this.loadData(this.options.filter(f => f.id === this.courseChildForm.AbilityTypeId)).then(data => {
                            if (this.courseChildForm.FirstAbilityId) {
                                this.loadData(data.filter(f => f.id === this.courseChildForm.FirstAbilityId))
                            }
                        })
                    }
            });
        },
        //获取学生列表
        getPageList(pageIndex) {
            console.log(this.$store.getters["organization/getCourseInfo"]());
            if (pageIndex) {
                this.tableRelevant.tablePagination.current = pageIndex;
            }
            const params = {
                OrganizationId: this.$store.getters["organization/getCourseInfo"]().organizationId,
                ProjectCourseConfigId: this.$store.getters["organization/getCourseInfo"]().id,
                pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                pageSize: this.tableRelevant.tablePagination.pageSize,
                ...this.searchForm
            };
            params.gradeClass = undefined;
            this.tableRelevant.tableLoading = true;
            this.$http.Course.getUserCourseChildProgress(params).then(res => {
                const {data} = res;
                this.tableRelevant.tableDataSource = data.items.map(m => {
                    if (m.progress <= 0) {
                        m.lastUpdateProgressTime = "--";
                    }
                    return m;
                });
                this.tableRelevant.tablePagination.total = data.totalCount;
            }).finally(() => {
              this.tableRelevant.tableLoading = false;
            })
        },
        //获取年级列表
        getGradeList() {
            this.$http.CommonInterface.getGradeClass({organizationId: this.$store.getters["organization/getCourseInfo"]().organizationId}).then(res => {
                const {data} = res;
                this.gradeList = data;
            })
        },
        getClassList(val) {
            this.searchForm.gradeId = val[0];
            this.searchForm.classId = val[1];
        },

        //重置
        searchReset() {
            this.searchForm = {
                gradeId: undefined,
                classId: undefined,
                courseChildName: undefined,
                userName: undefined,
                status: undefined,
                gradeClass: undefined
            };
            this.getPageList(1);
        },

        // 结算
        UserCourseChildSettlement(record) {
            let formData = new FormData()
            formData.append('userChildCourseId', record.projectCourseChildUserId)
            this.$http.Course.getUserCourseChildSettlement(formData)
                .then(res => {
                        this.$message.success(res.message)
                    
                }).finally(() => {
              this.tableRelevant.tableLoading = false;
            })
        },


        //重置内容点击内容替换关闭弹框刷新列表
        closeModal() {
            this.snapshotResetRelevant.visible = false;
            this.snapshotList();
        },
        //获取课时快照列表
        snapshotList(val, pageIndex) {
            this.snapshotRelevant.visible = true;
            this.snapshotTable.tableLoading = true;
            if (val) {
                this.snapshotRelevant.snapshotNowId = val.projectCourseChildId;
                this.snapshotRelevant.customerCourseId = val.projectCourseConfigId;
                this.snapshotRelevant.projectCourseChildUserId = val.projectCourseChildUserId;
                this.snapshotResetRelevant.nowInfo = val;
                this.allSnapshotResetId = val.courseChildId;
                sessionStorage.setItem('allSnapshotResetId', val.courseChildId)
            }
            if (pageIndex) {
                this.snapshotTable.tablePagination.current = pageIndex;
            }
            const params = {
                // ProjectCourseChildId: val ? val.projectCourseChildId : this.snapshotRelevant.snapshotNowId,
                customerChildCourseId: val ? val.projectCourseChildId : this.snapshotRelevant.snapshotNowId,
                customerCourseId: this.$store.getters["organization/getCourseInfo"]().id,
                userChildCourseId: val ? val.projectCourseChildUserId : this.snapshotRelevant.projectCourseChildUserId,
                pageIndex: pageIndex || this.snapshotTable.tablePagination.current,
                pageSize: this.snapshotTable.tablePagination.pageSize
            };

            this.$http.Course.snapshotPagelist(params).then(res => {
                const {data} = res;
                this.snapshotTable.tableDataSource = data.items;
                this.snapshotTable.tablePagination.total = data.totalCount;
            }).finally(() => {
              this.snapshotTable.tableLoading = false;
            })
        },
        //全部重置
        allSnapshotReset() {
            this.$message.destroy();
            if (!this.snapshotTable.tableDataSource.length) {
                this.$message.warn("无重置的内容");
                return
            }
            const that = this;
            this.$confirm({
                title: "确认要重置全部内容吗?",
                centered: true,
                onOk() {
                    const params = {
                        ProjectCourseConfigId:
                        that.$store.getters["organization/getCourseInfo"]().id,
                        ProjectCourseChildId: that.snapshotRelevant.snapshotNowId,
                        ChildCourseId: that.allSnapshotResetId
                    };
                    that.spinning = true;
                    that.$http.Course.replaceChangecontent(params).then(res => {
                        const {message} = res;
                        that.$message.success(message);
                        that.snapshotList();
                    }).finally(() => {
                      that.spinning = false;
                    })
                }
            });
        },
        //替换内容
        snapshotReset(val) {
            this.snapshotResetRelevant.visible = true;
            this.snapshotResetRelevant.contentId = val.contentId;
            this.allSnapshotResetId2 = sessionStorage.getItem('allSnapshotResetId')
            this.resetType = 1
            this.hadleTit = '替换'
            this.getCourseChildTableData()
            this.getCourseChildSnapshotContentIds()
        },
        modleOk() {
            this.snapshotRelevant.visible = false;
        },


        // 重新算分弹窗
        resetComputed() {
            this.isResetComputed = true
            this.getRcData()
        },
        //重新生成个人课时报告
        againReport() {
            this.$confirm({
                title: '是否重新生成个人课时报告?',
                centered: true,
                onOk: () => {
                  const Params = {
                    "organizationCourseId": this.$store.getters["organization/getCourseInfo"]().id,
                  };
                    this.againReportLoading = true;
                    this.$http.ReportService.UpdateEvaluationReports(Params).then(res => {
                      this.$message.success(res.message);
                    }).finally(() => {
                      this.againReportLoading = false;
                    })
                }
            });
        },
        // 获取弹窗数据
        getRcData() {
            let params = {
                projectCourseConfigId: this.$store.getters["organization/getCourseInfo"]().id
            };
            this.rcTable.tableLoading = true;
            this.$http.GetCourseEvaluationContents(params).then(res => {
                this.rcTable.tableLoading = false;
                const {status, data, message} = res.data;
                    this.rcTable.tableDataSource = data;
                    this.rcTable.tablePagination.total = data.length;
             
            }).catch(err => {
                this.rcTable.tableLoading = false;
                this.$message.error(err.data.message);
            })
        },


        //重置内容获取课程列表
        getCourseChildTableData(pageIndex) {
          let contentTypes = undefined;
          if (this.snapshotResetRelevant.nowInfo.childCourseType === 1) {
            contentTypes = this.$data._contentType.map((m, i) => {
              if (!i || i === 2) {
                return undefined
              }
              return i
            })
          }
          if (this.snapshotResetRelevant.nowInfo.childCourseType === 3) {
            contentTypes = [4, 6];
          }
            const params = {
                pageIndex: pageIndex || this.courseChildTable.tablePagination.current,
                pageSize: this.courseChildTable.tablePagination.pageSize,
                contentType: contentTypes,
                // userChildCourseId: this.snapshotResetRelevant.nowInfo.projectCourseChildUserId,
                ...this.courseChildForm
            };
            this.courseChildTable.tableLoading = true;

            this.$http.contentlist(params).then(res => {
                const data = res.data;
                    this.courseChildTable.tableDataSource = data.items;
                    this.courseChildTable.tablePagination.total = data.totalCount;
                    this.courseChildTable.tablePagination.current = data.pageIndex;
            }).finally(() => {
              this.courseChildTable.tableLoading = false;
              this.snapshotTable.tableLoading = false;
            })
        },
        getCourseChildSnapshotContentIds() {
            let params = {
                customerCourseId: this.$store.getters["organization/getCourseInfo"]().id,
                customerChildCourseId: this.snapshotResetRelevant.nowInfo.projectCourseChildId,
                userChildCourseId: this.snapshotResetRelevant.nowInfo.projectCourseChildUserId,
            }
            this.$http.Course.getCourseChildSnapshotContentIds(params).then(res => {
                const {data} = res;
                console.log(data);
                this.contentIds = data
            });
        },
        //重置搜索
        courseChildsearchReset(str) {
            for (let key in this.courseChildForm) {
                this.courseChildForm[key] = undefined;
            }
          this.courseChildForm.Enabled = true;
            this.firstAbility = [];
            this.selectId = [];
            this.secondAbility = [];
            if (str !== 'cancel') {
                this.getCourseChildTableData(1);
            }
        },
        //获取能力
        getAbility(id, type) {
            let params = {
                level: 0
            };
            if (id) {
                params = {
                    pid: id
                };
            }
            this.$http.CommonInterface.getAbility(params).then(res => {
                const {data} = res;
                switch (type) {
                    case 1:
                        this.firstAbility = data;
                        this.courseChildForm.secondAbilityId = undefined;
                        this.courseChildForm.firstAbilityId = undefined;
                        this.secondAbility = [];
                        break;
                    case 2:
                        this.secondAbility = data;
                        this.courseChildForm.secondAbilityId = undefined;
                        break;
                    default:
                        this.ability = data;
                }
            })
        },
        replace() {
            this.$message.destroy();
            if (!this.selectedRowKeys.length && this.resetType != 2) {
                this.$message.warn("请选择内容");
                return
            }
            this.executionsNumberVisible = true
        },
        executionsNumberOk(deleteId) {
            this.$message.destroy();
            if (!this.executionsNumber && this.resetType != 2) {
                this.$message.warn("请输入执行次数");
                return
            }
            const that = this;
            that.confirmLoading = true
            this.$confirm({
                title: '确认要' + that.hadleTit + '当前内容吗?',
                centered: true,
                okButtonProps: {
                    props: {loading: false},
                },
                onOk() {
                    that.confirmLoading = true
                    let params = {};
                    // 添加
                    if (that.resetType == 0) {
                        that.courseChildTable.tableLoading = true
                        params = {
                            customerCourseId: that.$store.getters["organization/getCourseInfo"]().id,
                            customerChildCourseId: that.snapshotResetRelevant.nowInfo.projectCourseChildId,
                            userChildCourseId: that.snapshotResetRelevant.nowInfo.projectCourseChildUserId,
                            contentId: that.selectedRowKeys[0].id,
                            executionsNumber: that.executionsNumber,
                            resetType: that.resetType,
                        }
                        // 替换
                    } else if (that.resetType == 1) {
                        that.courseChildTable.tableLoading = true
                        params = {
                            customerCourseId: that.$store.getters["organization/getCourseInfo"]().id,
                            customerChildCourseId: that.snapshotResetRelevant.nowInfo.projectCourseChildId,
                            originalContentId: that.snapshotResetRelevant.contentId,//添加不传
                            userChildCourseId: that.snapshotResetRelevant.nowInfo.projectCourseChildUserId,
                            contentId: that.selectedRowKeys[0].id,
                            executionsNumber: that.executionsNumber,
                            resetType: that.resetType,
                        }
                        //删除
                    } else {
                        that.snapshotTable.tableLoading = true;
                        params = {
                            customerCourseId: that.$store.getters["organization/getCourseInfo"]().id,
                            customerChildCourseId: that.snapshotResetRelevant.nowInfo.projectCourseChildId,
                            userChildCourseId: that.snapshotResetRelevant.nowInfo.projectCourseChildUserId,
                            originalContentId: deleteId,//添加不传
                            resetType: that.resetType,
                        }
                    }
                    that.$http.ChildCourseContentSnapshotReset(params)
                        .then(res => {
                            that.confirmLoading = false
                            that.executionsNumberVisible = false
                                that.snapshotResetRelevant.visible = false;
                                that.$message.success(res.message);
                                that.$emit("closeModal");
                                that.snapshotList();
                                that.selectedRowKeys = []
                        })
                        .finally(() => {
                            that.confirmLoading = false
                        })
                },
                onCancel() {
                    that.confirmLoading = false
                },
            });
        },
        // 添加内容
        addContent() {
            this.snapshotResetRelevant.visible = true;
            // this.snapshotResetRelevant.contentId = val.contentId;
            this.allSnapshotResetId2 = sessionStorage.getItem('allSnapshotResetId')
            this.resetType = 0
            this.hadleTit = '添加'
            this.getCourseChildTableData()
            this.getCourseChildSnapshotContentIds()
        },
        // 删除内容
        deleteContent(record) {
            this.resetType = 2
            this.hadleTit = '删除'
            this.executionsNumberOk(record.contentId)
        },
    }
}
</script>

<style scoped lang="less">
.serach-item {
    width: 180px;
    margin-bottom: 15px;
}

.operator {
    margin-top: 15px;
}

/deep/ .ant-table-tbody .multi-column {
    padding: 0 !important;

    .self_td {
        padding: 16px;
    }
}

</style>
